var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",on:{"click":_vm.action_Select}},[_c('span',{staticClass:"color_circle",style:(_vm.backgroundColorString)}),_c('span',{staticClass:"txt ellipsis"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }